import { render, staticRenderFns } from "./ModalTrialReview.vue?vue&type=template&id=ee0452a2&scoped=true"
import script from "./ModalTrialReview.vue?vue&type=script&lang=js"
export * from "./ModalTrialReview.vue?vue&type=script&lang=js"
import style0 from "./ModalTrialReview.vue?vue&type=style&index=0&id=ee0452a2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0452a2",
  null
  
)

export default component.exports